<template>
  <header class="header">
    <Container
      :breakpoints="{
        xs: 0,
        sm: 480,
        md: 768,
        lg: 1024,
        xl: 1280,
      }"
    >
      <div class="top-menu-wrapper">
        <router-link to="/main" class="logo-link">
          <div class="logo">
            <span :class="{ 'rotate-icon': isMenuOpen }" v-html="logoZerek" />
            <div class="logo-text">
              <p class="logo-text-title">ZEREK</p>
              <p class="logo-text-subtitle1">
                {{ $t("landing.zerekTitlePart1") }}
              </p>
              <p class="logo-text-subtitle2">
                {{ $t("landing.zerekTitlePart2") }}
              </p>
            </div>
          </div>
        </router-link>

        <div class="top-menu">
          <LanguageDropdown
            :languages="languages"
            @languageSelected="handleLanguageChange"
          />
          <div class="top-menu-buttons">
            <!-- <a href="#" class="menu-link">
            <span :class="{ 'rotate-icon': isMenuOpen }" v-html="supportIcon" />
            <TextField :enableHover="true" hoverColor="#3F51B5" weight="500">{{
              $t(`landing.support`)
            }}</TextField>
          </a> -->
            <a href="https://portal.zerek.edus.kz" class="center-link"
              ><TextField
                :enableHover="true"
                hoverColor="#3F51B5"
                weight="800"
                color="#0B43F1"
                >{{ $t(`landing.forCenters`) }}
              </TextField>
              <img src="@/assets/arrow-icon.svg" alt="Arrow"
            /></a>
            <Button
              v-if="!isAuthenticated"
              type="outline"
              borderRadius="24px"
              height="36px"
              width="fit-content"
              @click="goToLogin"
            >
              {{ $t(`landing.loginBtn`) }}
            </Button>
            <v-btn
              v-if="isAuthenticated && userInitials"
              icon
              x-large
              @click="goToLogin"
              class="profile-avatar-btn"
            >
              <v-avatar color="primary" size="40">
                <span class="white--text text-h7">{{ userInitials }}</span>
              </v-avatar>
            </v-btn>
            <!-- <v-menu
              v-if="isAuthenticated && userInitials"
              bottom
              min-width="200px"
              rounded
              offset-y
            >
              <template v-slot:activator="{ on }">
                <v-btn icon x-large v-on="on">
                  <v-avatar color="primary" size="40">
                    <span class="white--text text-h7">{{ userInitials }}</span>
                  </v-avatar>
                </v-btn>
              </template>
              <v-card>
                <v-list-item-content class="justify-center">
                  <div class="mx-auto text-center">
                    <v-avatar color="primary" size="40">
                      <span class="white--text text-h7">{{ userInitials }}</span>
                    </v-avatar>
                    <h5 class="mt-3" v-if="user">{{ user.name }}</h5>
                    <v-divider class="my-3"></v-divider>
                    <v-btn @click="goToLogin" depressed rounded text>
                      {{ $t(`landing.profileBtn`) }}
                    </v-btn>
                    <v-divider class="my-3"></v-divider>
                    <v-btn @click="logOut" depressed rounded text>
                      {{ $t(`landing.exitBtn`) }}
                    </v-btn>
                  </div>
                </v-list-item-content>
              </v-card>
            </v-menu> -->
          </div>
        </div>
      </div>

      <!-- Навигация -->
      <nav class="navbar">
        <ul class="navbar-menu">
          <li v-for="item in navItems" :key="item.name" class="navbar-item">
            <router-link
              :to="item.path"
              class="navbar-link"
              active-class="active-link"
            >
              <TextField
                tag="span"
                size="18"
                weight="500"
                color="#262626"
                hoverColor="#0056b3"
                :enableHover="true"
              >
                {{ $t(`landing.${item.name}`) }}
              </TextField>
            </router-link>
          </li>
        </ul>
      </nav>
    </Container>

    <!-- Мобильная навигация внизу -->
    <div class="mobile-bottom-nav" v-if="isMobile">
      <ul class="mobile-nav-menu">
        <li v-for="item in mobileNavItems" :key="item.name" class="mobile-nav-item">
          <router-link
            :to="item.path"
            class="mobile-nav-link"
            :exact="item.exact"
            active-class="active-link"
          >
            <v-icon 
              v-if="item.iconOutline" 
              size="24" 
              class="mobile-icon"
            >
              {{ item.iconOutline }}
            </v-icon>

            <v-icon 
              v-if="item.iconFilled" 
              size="24" 
              class="mobile-icon-filled"
            >
              {{ item.iconFilled }}
            </v-icon>
            
            <span class="mobile-nav-text">{{ $t(`landing.${item.name}`) }}</span>
          </router-link>
        </li>
      </ul>
    </div>

    <ProgressCircular v-if="isLoading" />
  </header>
</template>

<script>
import LanguageDropdown from "@/components/custom/LanguageDropdown.vue";
import { mapGetters } from "vuex";
import ProgressCircular from "@/components/custom/ProgressCircular.vue";
import Cookies from "js-cookie";
import supportIcon from "!!raw-loader!@/assets/support-icon.svg";
import logoZerek from "!!raw-loader!@/assets/logo_zerek.svg";

export default {
  components: {
    ProgressCircular,
    LanguageDropdown,
  },
  mounted() {
  },
  data: () => ({
    isLoading: false,
    supportIcon,
    logoZerek,
    languages: [
      { code: "kk", name: "Қазақша" },
      { code: "ru", name: "Русский" },
      // { code: "en", name: "English" },
    ],
    navItems: [
      { name: "popularCourses", path: "/popular-courses" },
      { name: "allCourses", path: "/courses" },
      { name: "tutoring", path: "/tutoring" },
      { name: "vacancies", path: "/vacancies" },
      // { name: "favorites", path: "/courses/favorites" },
    ],
    mobileNavItems: [
      { name: "main", path: "/main", iconOutline: "mdi-star-outline", iconFilled: "mdi-star", exact: false },
      { name: "allCoursesForMobile", path: "/courses", iconOutline: "mdi-book-open-variant-outline", iconFilled: "mdi-book-open-variant", exact: false },
      { name: "tutoringForMobile", path: "/tutoring", iconOutline: "mdi-account-tie-outline", iconFilled: "mdi-account-tie", exact: false },
      { name: "vacanciesForMobile", path: "/vacancies", iconOutline: "mdi-briefcase-outline", iconFilled: "mdi-briefcase", exact: false },
      { name: "profileBtn", path: "/profile", iconOutline: "mdi-account-outline", iconFilled: "mdi-account", exact: false },
    ],
    isMobileMenuOpen: false,
    isMenuOpen: false,
    drawer: null,
    items: [
      { title: "Home", icon: "mdi-view-dashboard" },
      { title: "About", icon: "mdi-forum" },
    ],
  }),
  computed: {
    ...mapGetters("auth", ["isAuthenticated"]),
    ...mapGetters("auth", ["user"]),
    userInitials() {
      const name =
        typeof this.user === "string" ? this.user : this.user?.user?.name;
      if (!name) return "U";
      const parts = name.trim().split(/\s+/);
      return parts
        .slice(0, 2)
        .map((p) => p[0].toUpperCase())
        .join("");
    },
    isMobile() {
      return window.innerWidth <= 640;
    }
  },
  methods: {
    getInitials(fullName) {
      if (!fullName) return "";
      const parts = fullName.trim().split(/\s+/);
      const firstTwo = parts.slice(0, 2);
      return firstTwo.map((word) => word.charAt(0).toUpperCase()).join("");
    },
    toggleMobileMenu() {
      this.isMobileMenuOpen = !this.isMobileMenuOpen;
    },
    logOut() {
      this.isLoading = true;
      this.$store.commit("auth/LOGOUT");

      setTimeout(() => {
        window.location.reload();
      }, 500);
    },
    goToLogin() {
      const firstEntry = Cookies.get("first_entry") === "true";
      const isAuthenticated = this.isAuthenticated;

      let targetRoute = isAuthenticated ? "/profile" : "/login";

      if (isAuthenticated && firstEntry) {
        targetRoute = "/registration";
      }

      if (this.$route.path === targetRoute) return;

      this.$router.replace(targetRoute);
    },
    handleLanguageChange(selectedLanguage) {
      console.log("Selected language:", selectedLanguage);
    },
    isActive(path) {
      if (path === '/popular-courses') {
        return this.$route.path.startsWith('/popular-courses');
      } else if (path === '/courses') {
        return this.$route.path.startsWith('/courses');
      }
      return this.$route.path === path;
    }
  },
};
</script>

<style scoped>
.container-md {
  max-width: 800px !important;
  margin: 0 auto !important;
}
::v-deep .theme--light.v-navigation-drawer .v-divider {
  margin: 12px 0;
}
.navbar-link.active-link {
  font-weight: bold;
  border-bottom: 2px solid #0056b3;
  margin-top: 5px;
}
.navbar-link.active-link span {
  color: #0056b3 !important;
}
.drawer-head {
  display: flex;
  align-items: center;
  margin-top: 10px;
}
.burger-menu {
  width: 40px;
  height: 40px;
  cursor: pointer;
  border-radius: 50%;
  transition: background-color 0.3s ease;
  display: none;
}
.burger-menu:hover {
  background-color: rgba(0, 0, 0, 0.1);
}
.burger-menu:active {
  background-color: rgba(0, 0, 0, 0.2);
}
.burger-icon {
  width: 24px;
  height: auto;
}
.top-menu-wrapper {
  display: flex;
  justify-content: space-between;
}
.header {
  background-color: #f5f8ff;
  padding: 15px 0 5px;
  border-bottom: 1px solid #eaeaea;
}
.container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.logo {
  display: flex;
  align-items: center;
  gap: 10px;
}

::v-deep.logo span svg {
  width: 40px;
  height: 40px;
}
.top-menu {
  display: flex;
  align-items: center;
  gap: 20px;
}
.menu-link {
  display: flex;
  align-items: center;
  gap: 5px;
}
.language-dropdown {
  display: flex;
  align-items: center;
  gap: 5px;
  cursor: pointer;
}
.center-link {
  display: flex;
  align-items: center;
  gap: 5px;
}
.login-btn {
  background-color: #ffffff;
  border: 2px solid #007bff;
  color: #007bff;
  padding: 5px 10px;
  border-radius: 5px;
  cursor: pointer;
}
.login-btn:hover {
  background-color: #007bff;
  color: #ffffff;
}
.navbar-menu {
  display: flex;
  justify-content: center;
  list-style: none;
  gap: 60px;
  padding: 0;
  margin: 0;
}
.navbar {
  padding: 30px 20px 0;
}
.navbar-item {
  position: relative;
}
.navbar-link {
  text-decoration: none;
  color: #333;
  font-size: 16px;
  font-weight: 500;
  position: relative;
  transition: color 0.3s ease;
}
.navbar-link:hover {
  color: #0056b3;
}
.navbar-link::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 0;
  height: 2px;
  background-color: #0056b3;
  transition: width 0.3s ease;
}

.navbar-link:hover::after {
  width: 100%;
}
.mobile-menu-btn {
  display: none;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
}

.logo-text-title {
    font-size: 16px;
    margin: 0;
    font-weight: bold;
    color: #000;
  }

.logo-text-subtitle1,
.logo-text-subtitle2 {
  font-size: 14px;
  margin: 0;
  line-height: 1.2;
  color: #666;
}

.top-menu-buttons {
  margin: 0;
  padding: 0;
  display: flex;
  align-items: center;
  gap: 20px;
}

.mobile-bottom-nav {
  display: none;
}

@media (max-width: 640px) {
  .container {
    flex-direction: column;
    align-items: flex-start;
  }
  .burger-menu {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .navbar {
    display: none;
  }
  .mobile-menu-btn {
    display: block;
    align-self: flex-end;
  }
  .mobile-visible {
    display: flex;
  }

  .top-menu-buttons {
    display: none;
  }
  
  .logo-text-title {
    font-size: 14px;
    margin: 0;
    font-weight: bold;
  }

  .logo-text-subtitle1,
  .logo-text-subtitle2 {
    font-size: 12px;
    margin: 2px 0;
    line-height: 1.2;
  }

  .header {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    z-index: 1000;
    padding: 10px 0 5px;
    background-color: #f5f8ff;
    border-bottom: 1px solid #eaeaea;
    max-height: 90px;
  }

  /* Мобильная навигация внизу */
  .mobile-bottom-nav {
    display: flex !important;
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: #ffffff;
    border-top: 1px solid #e0e0e0;
    padding: 8px 0 12px;
    z-index: 999;
    box-shadow: 0 -2px 15px rgba(0, 0, 0, 0.08);
    min-height: 64px;
    max-height: 85px;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  .mobile-nav-menu {
    display: flex;
    justify-content: space-around;
    align-items: stretch;
    width: 100%;
    list-style: none;
    margin: 0;
    padding: 0 16px;
    height: 100%;
  }

  .mobile-nav-item {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .mobile-nav-link {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    text-decoration: none;
    padding: 10px 8px;
    border-radius: 12px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    width: 100%;
    max-width: 72px;
    height: 100%;
    position: relative;
    overflow: hidden;
  }

  /* Иконки */
  .mobile-icon {
    color: #9c9c9c !important;
    margin-bottom: 6px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    opacity: 1;
    transform: translateY(0);
    position: relative;
    z-index: 2;
  }

  /* Текст */
  .mobile-nav-text {
    color: #9c9c9c !important; /* Фиолетовый цвет для текста */
    font-size: 11px;
    font-weight: 500;
    text-align: center;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    position: relative;
    z-index: 2;
    line-height: 1.2;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
  }

  /* Стили для активного состояния */
  .mobile-nav-link.active-link .mobile-icon {
    display: none !important; /* Скрываем outline иконку */
  }

  .mobile-nav-link.active-link .mobile-icon-filled {
    display: block !important; /* Показываем filled иконку */
    opacity: 1;
    position: relative;
    top: 0;
    color: #1A96FF !important; /* Синий цвет для активной иконки */
    margin-bottom: 6px;
    transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    transform: translateY(0);
    z-index: 2;
  }

  .mobile-nav-link.active-link .mobile-nav-text {
    color: #1A96FF !important; /* Синий цвет для активного текста */
    font-weight: 700;
  }

  /* Неактивное состояние */
  .mobile-icon-filled {
    display: none; /* Скрываем заполненные иконки по умолчанию */
  }

  /* Адаптация остальных элементов */
  .container {
    flex-direction: column;
    align-items: flex-start;
  }

  .top-menu-wrapper {
    width: 100%;
  }

  .top-menu-buttons {
    display: none;
  }

  .burger-menu {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  /* Отступ для контента */
  body {
    padding-bottom: 76px;
  }
}
</style>
